



export const portfolio =  [
        {
            "cover": require("../data/images/Invictus.webp"),
            "title": "Invictus Gym",
            "description": "Invictus Gym",
            "url": "https://invictusgym.netlify.app/"
        },
        {
            "cover":  require("../data/images/LuxeBistroKC.webp"),
            "title": "Luxe Bistro",
            "description": "Luxe Bistro",
            "url": "https://luxebistrokc.netlify.app/"
        },
        {
            "cover": require("../data/images/HomeProRenovations.webp"),
            "title": "HomePro Renovations",
            "description": "HomePro Renovations",
            "url": "https://homeprorenovations.netlify.app/"
        },
        {
            "cover": require("../data/images/WhiteOak.webp"),
            "title": "White Oak Dental",
            "description": "White Oak Dental",
            "url": "https://white-oak-dental.github.io/White-Oak-Dental/"
        },
        {
            "cover": require("../data/images/TW.webp"),
            "title": "T&W Web Design",
            "description": "T&W Web Design",
            "url": "https://twwebdesigns.com/"
        },
        // {
        //     "cover": require("../data/images/TinyTotsSpot.webp"),
        //     "title": "thespotfortopekatots.com",
        //     "description": "thespotfortopekatots.com",
        //     "url": "https://thespotfortopekatots.com/"
        // }
    ]
